import BaseCart from './base';

class Cart extends BaseCart {
  public cart: HTMLElement | null;
  public isReadOnly: boolean = true;
  public couponForm: HTMLFormElement | null;
  public couponRemoveBtn: HTMLElement | null;

  cache() {
    this.cart = document.querySelector('.js-cart');

    if (this.cart) {
      this.couponForm = this.cart.querySelector('.js-cart-coupon-form');
      this.couponRemoveBtn = this.cart.querySelector(
        '.js-cart-coupon-remove-btn'
      );
    }

    super.cache();
  }

  bindings() {
    if (this.couponRemoveBtn) {
      this.couponRemoveBtn.addEventListener('click', (e: Event) => {
        e.preventDefault();

        if (this.couponForm) {
          const couponInput: HTMLInputElement | null =
            this.couponForm.querySelector('input[name="couponCode"]');

          if (couponInput) {
            couponInput.value = '';

            this.couponForm.submit();
          }
        }
      });
    }

    super.bindings();
  }

  init() {
    if (document.querySelector('.js-cart-on-cart-page')) {
      this.cache();
      this.bindings();
    }
  }
}

export default Cart;
